import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  localStorage.setItem('prevRoute', from.path);

  next();
});

export default router;
